import {mapKeys, camelCase} from 'lodash';

export const DELIVERY_TIMES = {
    IMMEDIATE: "immediate",
    TODAY: "today",
    TOMORROW: "tomorrow",
    UP_TO_TWO_DAYS: "up_to_two_days",
    LATER: "later"
};

export class DeliveryMethod {
    static get FAST() { return 'fast'; }
    static get SUPERFAST() { return 'superfast'; }
    static get SUPERFAST_EXTENDED() { return 'superfast_extended'; }
    static get GIRO() { return 'giro'; }
    static get INTELI_EXPRESS() { return 'inteli_express'; }
    static get FENIGE() { return 'fenige'; }
    static get PRIVAT() { return 'privat'; }

    constructor() {
        this.name = null;
        this.enabled = null;
        this.deliveryTime = null;
        this.fee = null;
        this.paymentMethods = null;
        this.deliveryOptions = null;
    }

    static create(data) {
        data = mapKeys(data, (value, key) => camelCase(key));

        return Object.assign(new DeliveryMethod(), data);
    }

    get isFast() {
        return this.name === DeliveryMethod.FAST;
    }

    get isSuperFast() {
        return [DeliveryMethod.SUPERFAST, DeliveryMethod.SUPERFAST_EXTENDED].includes(this.name);
    }

    get isGiro() {
        return this.name === DeliveryMethod.GIRO;
    }

    get isInteliExpress() {
        return this.name === DeliveryMethod.INTELI_EXPRESS;
    }

    get isFenige() {
        return this.name === DeliveryMethod.FENIGE;
    }

    get isPrivat() {
        return this.name === DeliveryMethod.PRIVAT;
    }
}
